import React, { Component } from 'react';
import { connect } from 'react-redux';
// import LazyLoad  from 'react-lazyload';
import style from './style.css';
import HomeScreen from '../../components/homescreen';
import SwipeableViews from 'react-swipeable-views';
// import { StickyContainer, Sticky } from 'react-sticky';


class Home extends Component {
    constructor(props){
        super(props)
    }
    render() {
        return (
            <div className={ style.homeContainer }>
                <HomeScreen />
            </div>
        );
    }
}
                    // <LazyLoad once={true} height="375px" offset={[-200, 0]} placeholder={<Dots styles={{height: '300px'}}/>} debounce={100}>
                    // </LazyLoad>
                    // <LazyLoad once={true} height="400px" offset={[0, 0]} placeholder={<Dots styles={{height: '350px'}}/>} debounce={100}>
                    // </LazyLoad>
export default connect( 
    state =>({
        browser: state.browser,
    }),
    dispatch => { 
        return { 
            // _doGetMenu: () => { dispatch(doGetMenu()) } ,
        } 
    }
)(Home);



// WEBPACK FOOTER //
// ./src/routes/home/index.js